(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8812],{

/***/ 25753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ ToastIcon; }
});

// EXTERNAL MODULE: ./src/styles/stitches/index.ts + 2 modules
var stitches = __webpack_require__(62659);
;// CONCATENATED MODULE: ./src/components/global/ToastIcon/styles.ts

var ToastIconContainer = (0,stitches/* styled */.zo)('img', {
  width: '44px',
  height: '44px'
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/global/ToastIcon/index.tsx


function ToastIcon(_ref) {
  var type = _ref.type;
  var Icon = null;

  switch (type) {
    case 'success':
      Icon = /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIconContainer, {
        src: "/icons/confirm.svg",
        alt: "\xCDcone de confirma\xE7\xE3o"
      });
      break;

    case 'error':
      Icon = /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIconContainer, {
        src: "/icons/error.svg",
        alt: "\xCDcone de confirma\xE7\xE3o"
      });
      break;

    default:
      Icon = /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIconContainer, {
        src: "/icons/confirm.svg",
        alt: "\xCDcone de confirma\xE7\xE3o"
      });
      break;
  }

  return Icon;
}

/***/ }),

/***/ 84422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ForgotPassword; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/styles/stitches/index.ts + 2 modules
var stitches = __webpack_require__(62659);
;// CONCATENATED MODULE: ./src/styles/pages/ForgotPassword.tsx

var fadeInForgotPassword = (0,stitches/* keyframes */.F4)({
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
});
var hoverArrow = (0,stitches/* keyframes */.F4)({
  '0%': {
    transform: 'translate(0px, -5px)'
  },
  '50%': {
    transform: 'translate(-5px, -5px)'
  },
  '100%': {
    transform: 'translate(0px, -5px)'
  }
});
var hoverButton = (0,stitches/* keyframes */.F4)({
  '0%': {
    scale: '1.05'
  },
  '50%': {
    scale: '1'
  },
  '100%': {
    scale: '1.05'
  }
});
var Container = (0,stitches/* styled */.zo)('div', {
  width: '100%',
  background: 'linear-gradient(178.86deg, #4521AB 10.17%, rgba(69, 33, 171, 0.92) 27.44%, rgba(69, 33, 171, 0.88) 43.28%, rgba(69, 33, 171, 0.85421) 61.51%, rgba(69, 33, 171, 0.824252) 78.31%, rgba(69, 33, 171, 0.8) 90.78%, rgba(69, 33, 171, 0.74) 99.02%);',
  display: 'flex',
  minHeight: '100vh'
});
var Wrapper = (0,stitches/* styled */.zo)('div', {
  maxWidth: '90rem',
  width: '100%',
  margin: '0 auto',
  display: 'flex',
  minHeight: '100vh',
  padding: '$5',
  animation: "".concat(fadeInForgotPassword, " ease-in 0.5s")
});
var NextouContainer = (0,stitches/* styled */.zo)('div', {
  width: '50%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '0.625rem',
  padding: '3.5rem $12',
  position: 'relative',
  background: '$brightColour',
  'img#logo': {
    width: '8.2625rem',
    height: '2.5656rem',
    position: 'absolute',
    top: '3.5rem',
    left: '2.75rem'
  },
  'img#nextou': {
    maxWidth: '34.5625rem',
    height: '34.8125rem',
    width: '100%'
  },
  p: {
    color: '$texts',
    fontSize: '$xl',
    fontWeight: '$medium',
    lineHeight: '30px',
    maxWidth: '28.4375rem',
    width: '100%'
  },
  '@media (max-width: 920px)': {
    display: 'none'
  }
});
var ForgotPasswordContainer = (0,stitches/* styled */.zo)('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  width: '50%',
  borderTopRightRadius: '0.625rem',
  borderBottomRightRadius: '0.625rem',
  '@media (max-width: 920px)': {
    minHeight: '100vh',
    width: '100%',
    padding: '0px 1rem'
  }
});
var ForgotPasswordWrapper = (0,stitches/* styled */.zo)("div", {
  maxWidth: '21.4375rem',
  width: '100%',
  margin: '0 auto',
  strong: {
    marginTop: '$15',
    fontFamily: 'Poppins',
    fontWeight: 700,
    fontSize: '$2xl',
    color: '$brightColour',
    display: 'block'
  },
  p: {
    marginTop: '$5',
    fontFamily: '$default',
    fontWeight: 400,
    fontSize: '$sm',
    color: '$brightColour',
    display: 'block'
  }
});
var ForgotPasswordHeader = (0,stitches/* styled */.zo)('header', {
  display: 'flex',
  alignItems: 'center',
  img: {
    flex: 1
  },
  svg: {
    transform: 'translateY(-5px)',
    cursor: 'pointer',
    '&:hover': {
      animation: "".concat(hoverArrow, " ease-in 0.5s infinite")
    }
  }
});
var ForgotPasswordForm = (0,stitches/* styled */.zo)('form', {
  marginTop: '46px',
  div: {
    borderBottom: '1px solid $brightColour',
    paddingBottom: '$1',
    display: 'flex',
    alignItems: 'center',
    gap: '$3',
    position: 'relative',
    width: '100%',
    svg: {
      position: 'absolute',
      left: 0
    },
    input: {
      height: '1.75rem',
      zIndex: 3,
      width: '100%',
      paddingLeft: '$11',
      background: 'transparent',
      border: 0,
      outline: '0',
      color: '$brightColour',
      fontSize: '$md',
      '&:disabled': {
        cursor: 'not-allowed'
      },
      '&::placeholder': {
        color: '$brightColour',
        fontSize: '$md'
      }
    }
  },
  button: {
    width: '100%',
    height: '2.9975rem',
    borderRadius: '$xl',
    background: '$secondaryButtonBackground',
    border: 0,
    color: '$secondaryButtonColor',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '$md',
    marginTop: '$22',
    cursor: 'pointer',
    '&:hover': {
      animation: "".concat(hoverButton, " ease-in 0.5s infinite")
    },
    '&:disabled': {
      cursor: 'not-allowed',
      animation: "".concat(hoverButton, " ease-in 0s")
    }
  }
});
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/lib-esm/Auth.js + 133 modules
var Auth = __webpack_require__(96797);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/components/pages/ForgotPassword/styles.ts

var fadeInSignIn = (0,stitches/* keyframes */.F4)({
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
});
var ModalForm = (0,stitches/* styled */.zo)('form', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100%',
  gap: '$5',
  'strong , p ': {
    color: '$brightColour'
  },
  input: {
    border: 'none',
    width: '10.625rem',
    color: '$brightColour',
    background: 'repeating-linear-gradient(90deg, $brightColour 0, $brightColour 1ch, transparent 0, transparent 1.5ch) 0 100%/100% 2px no-repeat',
    font: '32px consolas, monospace',
    letterSpacing: '.5ch',
    height: '1.875rem',
    '&:focus': {
      outline: 'none',
      color: '$brightColour'
    }
  },
  button: {
    width: '100%',
    height: '2.625rem',
    borderRadius: '$md',
    border: '2px solid $secondary',
    background: '$brightColour',
    fontWeight: 'bold',
    transition: 'color 0.2s ease-in',
    position: 'relative',
    animation: "".concat(fadeInSignIn, " ease-in 0.5s"),
    '&:hover': {
      color: '$secondary'
    },
    '&:disabled': {
      cursor: 'not-allowed'
    },
    marginTop: '$3'
  }
});
var CodeGroup = (0,stitches/* styled */.zo)('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  alignItems: 'center'
});
var PasswordForm = (0,stitches/* styled */.zo)('form', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100%',
  gap: '$8',
  strong: {
    color: '$brightColour',
    fontSize: '$2xl'
  },
  div: {
    width: '100%',
    'strong.error': {
      color: 'red',
      fontSize: '$md'
    }
  }
});
var InputGroup = (0,stitches/* styled */.zo)('div', {
  borderBottom: '1px solid $brightColour',
  paddingBottom: '$1',
  display: 'flex',
  alignItems: 'center',
  gap: '$3',
  position: 'relative',
  width: '100%',
  svg: {
    position: 'absolute',
    left: 0
  },
  input: {
    height: '1.75rem',
    zIndex: 3,
    width: '100%',
    paddingLeft: '$11',
    background: 'transparent',
    border: 0,
    outline: '0',
    color: '$brightColour',
    fontSize: '$md',
    '&:disabled': {
      cursor: 'not-allowed'
    },
    '&::placeholder': {
      color: '$brightColour',
      fontSize: '$md'
    }
  }
});
var ModalFormFooter = (0,stitches/* styled */.zo)('div', {
  display: 'flex',
  gap: '$3',
  width: '100%',
  borderBottom: '0 !important',
  '@media (max-width: 920px)': {
    flexDirection: 'column'
  },
  button: {
    width: '100%',
    height: '2.625rem',
    borderRadius: '$md',
    border: '2px solid $secondary',
    background: '$brightColour',
    fontWeight: 'bold',
    transition: 'color 0.2s ease-in',
    position: 'relative',
    animation: "".concat(fadeInSignIn, " ease-in 0.5s"),
    '&:hover': {
      color: '$secondary'
    },
    '&:disabled': {
      cursor: 'not-allowed'
    },
    marginTop: '$3'
  },
  variants: {
    isLoading: {
      "true": {
        button: {
          cursor: 'not-allowed',
          '&:hover': {
            color: '#262626'
          }
        }
      }
    }
  }
});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./src/components/global/ToastIcon/index.tsx + 1 modules
var ToastIcon = __webpack_require__(25753);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/ForgotPassword/index.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var PasswordFormValidation = yup_index_esm/* object */.Ry().shape({
  password: yup_index_esm/* string */.Z_().required('Digite sua senha!').min(8, 'A senha deve conter no mínimo 8 dígitos!').matches(/[A-Z]/, 'A senha deve conter letras maiúsculas!').matches(/[a-z]/, 'A senha deve conter letras minúsculas!').matches(/[0-9]/, 'A senha deve conter números!').matches(/\W/, 'A senha deve conter caracteres especiais!'),
  confirmPassword: yup_index_esm/* string */.Z_().min(8, 'Senha deve conter pelo menos 8 caracteres').required('Por favor, informe a senha').oneOf([yup_index_esm/* ref */.iH('password')], 'As senhas devem ser iguais!')
});
function ModalForgotPassword(_ref) {
  var _errors$password, _errors$confirmPasswo;

  var onClose = _ref.onClose,
      email = _ref.email;

  var _useState = (0,react.useState)(''),
      code = _useState[0],
      setCode = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,react.useState)('code'),
      typeForm = _useState3[0],
      setTypeForm = _useState3[1];

  function handleSubmitCodeForm(event) {
    event.preventDefault();
    setTypeForm('newPassword');
  }

  var router = (0,next_router.useRouter)();

  var _useForm = (0,dist_index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(PasswordFormValidation)
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  function submit(_x) {
    return _submit.apply(this, arguments);
  }

  function _submit() {
    _submit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var password;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              password = _ref2.password;
              _context.prev = 1;
              setIsLoading(true);
              _context.next = 5;
              return Auth/* Auth.forgotPasswordSubmit */.g.forgotPasswordSubmit(email, code, password);

            case 5:
              react_toastify_esm/* toast.success */.Am.success( /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Senha alterada com sucesso"
              }), {
                icon: /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIcon/* ToastIcon */.I, {
                  type: "success"
                })
              });
              router.push('/');
              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);
              react_toastify_esm/* toast.error */.Am.error( /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Erro ao tentar atualzar senha"
              }), {
                icon: /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIcon/* ToastIcon */.I, {
                  type: "error"
                })
              });
              setIsLoading(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));
    return _submit.apply(this, arguments);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((lib_default()), {
    isOpen: true,
    contentLabel: "Login With Email",
    style: {
      content: {
        maxWidth: '450px',
        height: '400px',
        width: '100%',
        background: '#2C0E80',
        border: '1px solid #AEA0E8'
      }
    },
    children: [typeForm === 'code' && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalForm, {
      onSubmit: handleSubmitCodeForm,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CodeGroup, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Enviamos um c\xF3digo para seu E-Mail"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Digite o c\xF3digo a baixo:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          maxLength: 6,
          value: code,
          onChange: function onChange(event) {
            return setCode(event.target.value);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalFormFooter, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: onClose,
            children: "Cancelar"
          }), code.length === 6 && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "submit",
            disabled: code.length < 6,
            children: "Continuar"
          })]
        })]
      })
    }), typeForm === 'newPassword' && /*#__PURE__*/(0,jsx_runtime.jsxs)(PasswordForm, {
      onSubmit: handleSubmit(submit),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Definir nova senha"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputGroup, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ri_index_esm/* RiLockPasswordFill */.xuE, {
            size: 30,
            color: "#fff"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register('password')), {}, {
            type: "password",
            disabled: isLoading,
            placeholder: "Senha"
          }))]
        }), !!((_errors$password = errors.password) !== null && _errors$password !== void 0 && _errors$password.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          className: "error",
          children: errors.password.message
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputGroup, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ri_index_esm/* RiLockPasswordFill */.xuE, {
            size: 30,
            color: "#fff"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register('confirmPassword')), {}, {
            type: "password",
            disabled: isLoading,
            placeholder: "Confirmar Senha"
          }))]
        }), !!((_errors$confirmPasswo = errors.confirmPassword) !== null && _errors$confirmPasswo !== void 0 && _errors$confirmPasswo.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          className: "error",
          children: errors.confirmPassword.message
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalFormFooter, {
        children: [!isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          onClick: onClose,
          children: "Cancelar"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "submit",
          disabled: isLoading,
          children: isLoading ? 'Atualizando' : 'Continuar'
        })]
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/esqueci-minha-senha/index.tsx













function ForgotPassword() {
  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = (0,react.useState)(false),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      email = _useState3[0],
      setEmail = _useState3[1];

  var handleCloseModal = (0,react.useCallback)(function () {
    setOpenModal(false);
  }, []);

  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }

  function _handleSubmit() {
    _handleSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event === null || event === void 0 ? void 0 : event.preventDefault();
              setIsLoading(true);

              if (!email.length) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return Auth/* Auth.forgotPassword */.g.forgotPassword(email);

            case 5:
              setOpenModal(true);

            case 6:
              setIsLoading(false);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleSubmit.apply(this, arguments);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [openModal && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalForgotPassword, {
      onClose: handleCloseModal,
      email: email
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Nextou - Esqueci Minha Senha"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(NextouContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          alt: "Logo",
          src: "/logo.svg",
          width: 137,
          height: 43.93,
          id: "logo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 553,
          height: 557,
          src: "/nextouLogin.svg",
          alt: "Nextou",
          id: "nextou"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Fa\xE7a com que o aprendizado fique ao alcance de todos. Comece agora mesmo!"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ForgotPasswordContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ForgotPasswordWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ForgotPasswordHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              prefetch: false,
              href: "/",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BsChevronLeft */.pjk, {
                  color: "#fff",
                  size: 40
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/purpleNextou.svg",
              alt: "Nestor",
              width: 137,
              height: 43.93
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Esqueceu sua senha?"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "N\xE3o se preocupe, recupere sua conta!"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ForgotPasswordForm, {
            onSubmit: handleSubmit,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdOutlineEmail */.F8X, {
                color: "#fff",
                size: 30
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                value: email,
                onChange: function onChange(event) {
                  return setEmail(event.target.value);
                },
                type: "email",
                disabled: isLoading,
                placeholder: "Digite seu email"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "submit",
              disabled: isLoading || !email.length,
              children: "Enviar"
            })]
          })]
        })
      })]
    })]
  });
}

/***/ }),

/***/ 85408:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/esqueci-minha-senha",
      function () {
        return __webpack_require__(84422);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56249:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,688,5937,2013,9070,3987,7536,2216,9774,2888,179], function() { return __webpack_exec__(85408); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);